//
//
//
//
//
//
//
//
//

import { SearchIcon } from 'vue-feather-icons'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'QuickSearch',
  components: {
    SearchIcon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    term: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      searchTerm: null
    }
  },
  mounted () {
    this.searchTerm = this.term
  },
  methods: {
    search () {
      this.$emit('search', this.searchTerm)
    }
  }
}
